import axios, {AxiosError, AxiosPromise, AxiosRequestConfig, AxiosResponse} from 'axios'
import { CsvDownload } from "@/types/APIResponse";
import { LoginUser } from "@/types/Component";
import { toCamel } from 'snake-camel';
import moment from 'moment';

export default class ApiClient {
    private store: any;
    private apiServerBaseUrl: string;
    private loginUrl: string;
    private tokenUrl: string;
    private apiCgBaseUrl: string;
    private isLoginInProgress = false;

    private shouldSelectAll = true;
    private clickCount = 0;
    private lastClickedSegment: 'year' | 'month' | 'day' | null = null;
    private flag = false;
    private initialDate = '';

    public constructor(store: any) {
        this.store = store
        this.apiServerBaseUrl = process.env.VUE_APP_API_URL_BASE
        this.loginUrl = process.env.VUE_APP_LOGIN_URL
        this.tokenUrl = process.env.VUE_APP_TOKEN_URL
        this.apiCgBaseUrl= process.env.VUE_APP_CG_API_URL
    }

    public async getUserProfile() {
        const data = toCamel(await this.profileRequest('get', '/profile')) as LoginUser;
        if(data.statusCode == 403 && data.errorMessage !=null){
            window.alert(data.errorMessage);
            return location.href = "/oauth2/logout"
        }
        if(data.statusCode == 403){
            this.store.dispatch('doUpdateDeleteTenantAlertPopUp', true);
            this.store.dispatch('doUpdateLastTenantId',null)
        }
        else{
            this.store.dispatch('doUpdateDeleteTenantAlertPopUp', false);
        }
        this.store.dispatch('doUpdateLoginUser', data);
        this.redirectToTenantBasePath()
        return this.store.getters.loginUser;
    }

    public setTenantId() {
        if(this.getTenantId()) {
            this.store.dispatch('doUpdateLastTenantId', this.getTenantId());
        }
    }

    public redirectToTenantBasePath() {
        const loginUser = this.store.getters?.loginUser
        const webDefaultTenant = loginUser?.webDefaultTenantID;
        const defaultTenantId = loginUser?.tenantDetailsList.find(
            (item:any) => webDefaultTenant === item.id
        );
        const tenantDetailsList = loginUser?.tenantDetailsList;
        if (!tenantDetailsList.length) {
            this.store.dispatch('doUpdateCurrentPageName', '');
            this.store.dispatch('doUpdateParentPageName', '');
            this.store.dispatch('doUpdateDeleteTenantAlertPopUp', false);
            window.alert("利用可能なテナントが存在しません。ログアウトします。");
            return location.href = "/oauth2/logout"
        } else {
            const defaultTenant = defaultTenantId ? webDefaultTenant : tenantDetailsList[0].id;
            if (!this.getTenantId() && defaultTenant) {
                this.store.dispatch('doUpdateDeleteTenantAlertPopUp', false);
                window.location.href = `/tenants/${defaultTenant}/`;
            } else if (this.getTenantId() !== defaultTenant && this.store.getters.deleteTenantAlertPopUp == false) {
                const getTenantName = (id: any) => tenantDetailsList.find((t: { id: any; }) => t.id === id)?.tenantName ?? id;
                const currentTenantName = getTenantName(defaultTenant);
                const urlTenantName = getTenantName(this.getTenantId());
                if (window.confirm(`現在、使用しているテナント「${currentTenantName}」と異なります。\nテナント「${urlTenantName}」に変更しますか？`)) {
                    const params = {
                        id: this.getTenantId(),
                        kind: "WEB"
                    }
                    this.doRequest("post", "/profile", params).then((res) => {
                        this.store.dispatch('doUpdateIsTenantChanged', true);
                        this.store.dispatch('doUpdateLastTenantId', this.getTenantId());
                        location.reload();
                    })
                } else {
                    let updatedPath = location.pathname.replace(`/tenants/${this.getTenantId()}`, `/tenants/${defaultTenant}`);
                    let pathParts = updatedPath.split('/');
                    const tenantIndex = pathParts.indexOf(defaultTenant);
                    const hasMaster = pathParts.includes('master');
                    const hasHarvestShipping = pathParts.includes('harvest_shipping');
                    const hasAggregation = pathParts.includes('aggregation');
                    const hasAdditionalFunction = pathParts.includes('additional-function');
                    const hasManagement = pathParts.includes('management');
                    const hasList = pathParts.includes('list');
                    const hasRecord = pathParts.includes('record');
                    const hasCommon = pathParts.includes('calendar') || pathParts.includes('dashboard');
                    const hasUserList = pathParts.includes('user-list');
                    const hasNotification = pathParts.includes('notification-status-by-notification') || pathParts.includes('notification-subscriber') || pathParts.includes('notification-register');
                    if ((hasMaster && hasHarvestShipping) || hasAggregation) {
                        pathParts = pathParts.slice(0, tenantIndex + 4);
                    } else if (hasMaster || hasAdditionalFunction || hasManagement || hasList || hasRecord || hasCommon) {
                        pathParts = pathParts.slice(0, tenantIndex + 3);
                    } else if (hasUserList || hasNotification) {
                        pathParts = pathParts.slice(0, tenantIndex + 2);
                    }
                    updatedPath = pathParts.join('/');
                    window.location.href = `${location.origin}${updatedPath}`;
                }
            } else {
                const adminScreens = [
                    'aggregation', 'management', 'additional-function', 'dashboard', 'list/shipping', 
                    'master/harvest_shipping/shipping_destinations', 'master/warehouses', 'user-list'
                ];
                const notificationAdminScreens = [
                    'notification-status-by-notification', 'notification-subscriber', 'notification-register','chemical-import-error-list','item-hiragana-change'
                ];
                const pesticidePlanDenyScreens = [
                    'aggregation', 'management', 'additional-function', 'dashboard', 'list/shipping', 'list/harvest','list/work','list/plantings',
                    'master/harvest_shipping', 'master/warehouses' , 'master/machines','master/materials','/master/work_items','record/disposal'
                ];
                const pesticidePlanProducersDenyScreens = [
                    'master/committees','pesticide-navigator/producer-list'
                ];
                const pesticidePlanScreens = [
                    'master/committees','pesticide-navigator'
                ];
                const currentURL = window.location.href;
                if (!this.isAdmin && adminScreens.some(screen => currentURL.includes(screen))) {
                    window.alert("この画面をアクセスする権限がありません。カレンダー画面へ遷移します。");
                    return window.location.href = `/tenants/${defaultTenant}/`;
                }
                if (!this.store.getters.loginUser.notificationWokerAdmin && notificationAdminScreens.some(screen => currentURL.includes(screen))) {
                    window.alert("この画面をアクセスする権限がありません。カレンダー画面へ遷移します。");
                    return window.location.href = `/tenants/${defaultTenant}/`;
                }
                if (this.store.getters.loginUser.isPesticidePlan && pesticidePlanDenyScreens.some(screen => currentURL.includes(screen))) {
                    window.alert("この画面をアクセスする権限がありません。カレンダー画面へ遷移します。");
                    return  window.location.replace(`/tenants/${defaultTenant}/`);
                }
                if (this.store.getters.loginUser.pesticidePlanProducer && !this.store.getters.loginUser.isPesticidePlan  && pesticidePlanProducersDenyScreens.some(screen => currentURL.includes(screen))) {
                    window.alert("この画面をアクセスする権限がありません。カレンダー画面へ遷移します。");
                    return  window.location.replace(`/tenants/${defaultTenant}/`);
                }
                if (!this.store.getters.loginUser.isPesticidePlan && !this.store.getters.loginUser.pesticidePlanProducer && pesticidePlanScreens.some(screen => currentURL.includes(screen))) {
                    window.alert("この画面をアクセスする権限がありません。カレンダー画面へ遷移します。");
                    return  window.location.replace(`/tenants/${defaultTenant}/`);
                }
            }
        }
    }

    get isAdmin(): boolean {
        return this.store.getters?.loginUser.role.find((r: string) => {
            return r === 'ADMIN'
        }) !== undefined;
    }

    public errorAlert(statusCord: number, message: string | undefined) {
        const alertMessage = 'リクエストに失敗しました。\n'
        if(message) {
            // サーバからエラーメッセージが返却されている場合はそれを表示する
            window.alert(alertMessage + message)
            return false
        }
        switch (statusCord) {
            case 403:
                window.alert('このテナントには、アクセスする権限がありません。ログアウトします。');
                return location.href = "/oauth2/logout"
            case 404:
                window.alert(alertMessage + '対象のリソースが削除された可能性があります。')
                break
            case 409:
                window.alert(alertMessage + '名称が重複している可能性があります。')
                break
            case 428:
                window.alert(alertMessage + '他のユーザにより対象データが更新されています。')
                break
            case 400:
                window.alert(alertMessage + 'リクエスト内容が不正です。')
                break
            case 500:
                window.alert(alertMessage + '予期しないエラーです。サポートに連絡してください。')
                break
        }
    }

    public async profileRequest(method: "get"|"post"|"put"|"delete", url: string, params?: any) {
        const accessToken = this.store.getters.accsessToken
        const tenantId = this.getTenantId() || this.store.getters.tenantId;
        const config: AxiosRequestConfig = {
            url: `${this.apiServerBaseUrl}${url}`,
            method: method,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${accessToken}`,
                'agri-tenant-id': tenantId
            },
            data: params,
            withCredentials: true
        }
        try {
            const res = await axios(config);
            return res.data;
        } catch (error) {
            if (error.response.status === 403) {
                window.alert('このテナントには、アクセスする権限がありません。ログアウトします。');
                location.href = "/oauth2/logout"
            }
            if (error.response.status === 401) {
                await this.getAccessToken()
            }
            else if (error.response.status === 404) {
                window.alert("利用可能なテナントが存在しません。ログアウトします。");
                location.href = "/oauth2/logout"
            }
            else if(error.response.status === 400){
                window.alert('リクエスト内容が不正です。')
            }
            else if(error.response.status === 500){
                window.alert('予期しないエラーです。サポートに連絡してください。')
            }
            else if(error.response.status === 428){
                window.alert('他のユーザにより対象データが更新されています。')
            }
            else if(error.response.status === 409){
                window.alert('名称が重複している可能性があります。')
            }   
            return Promise.reject(error.response)
        }
    }

    public async doRequest(method: "get"|"post"|"put"|"delete", url: string, params?: any) {
        const accessToken = this.store.getters.accsessToken
        const tenantId = this.getTenantId() || this.store.getters.tenantId;
        const config: AxiosRequestConfig = {
            url: `${this.apiServerBaseUrl}${url}`,
            method: method,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${accessToken}`,
                'agri-tenant-id': tenantId
            },
            data: params,
            withCredentials: true
        }
        try {
            const res = await axios(config);
            return res.data;
        } catch (error) {
            if (error.response.status === 401) {
                await this.getAccessToken()
            }
            this.errorAlert(error.response.status, error.response.data?.message)
            return Promise.reject(error.response)
        }
    }

    public async cloudGearRequest(method: "get" | "post" | "delete", url: string, params?: any) {
        const accessToken = this.store.getters.accsessToken
        const config: AxiosRequestConfig = {
            url: `${this.apiCgBaseUrl}${url}`,
            method: method,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${accessToken}`,
            },
            data: params,
        }
        try {
            const res = await axios(config);
            return res.data;
        } catch (error) {
            if (error.response.status === 401) {
                await this.getAccessToken()
            }
            return Promise.reject(error.response)

        }
    }

    public async fileUpload(url: string, file: any) {
        const accessToken = this.store.getters.accsessToken
        const tenantId = this.getTenantId() || this.store.getters.tenantId;
        const formData = new FormData()
        formData.append('file', file)
        const config: AxiosRequestConfig = {
            url: `${this.apiServerBaseUrl}${url}`,
            method: 'post',
            headers: {
                'content-type': 'multipart/form-data',
                'Authorization': `Bearer ${accessToken}`,
                'agri-tenant-id': tenantId
            },
            data: formData,
            withCredentials: true
        }
        try {
            const res = await axios(config);
            return res.data;
        } catch (error) {
            if (error.response.status === 401) {
                await this.getAccessToken()
            }
            this.errorAlert(error.response.status, error.response.data?.message)
            return Promise.reject(error.response)
        }
    }

    public async getAccessToken(callback?: any): Promise<string> {
        return await axios.get(this.tokenUrl, {
            withCredentials: true
        })
        .then((res)=>{
            const data = res.data
            const status = res.status
            if(status === 200){
                this.store.dispatch('doUpdateSession', data)
                if(callback !== undefined){
                    callback()
                }
            } else {
                this.login()
            }
            return this.store.getters.accsessToken
        })
        .catch((error) => {
            this.login()
        })
    }

    public login(): void {
        if (this.isLoginInProgress) {
            return;
        }
        this.isLoginInProgress = true;
        const callbackUrl = encodeURI(window.location.href);
        window.location.replace(`${this.loginUrl}?callback_url=${callbackUrl}`);
    }

    public getTenantId(): string {
        // パスから取得
        const regstr = new RegExp('/tenants/([^/]+)');
        const regx = location.pathname.match(regstr);
        if(regx && regx.length > 0) {
            return regx[1];
        } else {
            return ''
        }
    }

    public getBase64(file: any) {
        // アップロードしたファイルをBase64形式に変換しPromiseで返す
        return new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = () => resolve({ base64: reader.result, file: file })
            reader.onerror = error => reject(error)
        })
    }

    public fileSizeFormat(bytes: number) {
        const sizes: string[] = ['Bytes', 'KB', 'MB', 'GB', 'TB']
        if (bytes == 0) return '0 Byte'
        const i: number = parseInt(String(Math.floor(Math.log(bytes) / Math.log(1024))))
        return Math.round(bytes / Math.pow(1024, i)) + ' ' + sizes[i]
    }

    public isSizeOver(fileList: any): boolean {
        // サイズチェックしてオーバーしていたらtrueを返しアラートを表示する
        let isSizeOver = false
        const sizeLimit = 20971520 // 20MB

        const files = Array.from(fileList)

        files.forEach((file: any) => {
            if (sizeLimit && file.size > sizeLimit) {
                isSizeOver = true
            }
        })

        if (isSizeOver) {
            const maxFileSize = this.fileSizeFormat(sizeLimit)
            window.alert(
                `アップロードできるファイルの最大サイズは${maxFileSize}です`
            )
            return true
        }else {
            return false
        }
    }

    public isImageFile(fileName: string): boolean {
        // ファイルが画像だったらtrue、それ以外だったらfalseを返す
        const f = fileName.split('.')
        const extension = f[f.length-1].toLowerCase()
        if( extension == 'bmp' || extension == 'gif' || extension == 'jpeg' || extension == 'jpg' || extension == 'tiff' || extension == 'tif' || extension == 'png' ) {
            return true
        }else {
            return false
        }
    }

    // returnにdataだけでなくheaderなどを含めた全てを返す
    public async getRequest(url: string, params?: any) {
        const accessToken = this.store.getters.accsessToken
        const tenantId = this.getTenantId() || this.store.getters.tenantId;
        const config: AxiosRequestConfig = {
            url: `${this.apiServerBaseUrl}${url}`,
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${accessToken}`,
                'agri-tenant-id': tenantId
            },
            data: params,
            withCredentials: true
        }
        try {
            const res = await axios(config);
            return res;
        } catch (error) {
            if (error.response.status === 401) {
                await this.getAccessToken()
            }
            this.errorAlert(error.response.status, error.response.data?.message)
            return Promise.reject(error.response)
        }
    }

    public csvDownload(response: CsvDownload): void {
        const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
        const blob = new Blob([bom, response.data], {type: 'text/csv'})

        const link = document.createElement('a')
        const downloadUrl = window.URL.createObjectURL(blob)
        link.href = downloadUrl
        link.download = decodeURIComponent(response.headers["csv-file-name"])
        link.click()
        URL.revokeObjectURL(downloadUrl);
    }

    public validateInputInteger(event: InputEvent) {
        // 入力値を取得
        const data = event.data
        // 数値のみ許容
        const pattern = /^\d*$/;
        // 文字削除時はdataがnullになるためそのまま通す
        if(data != null && !pattern.test(data)) {
            // pattern外のときは入力をキャンセルする
            return event.preventDefault()
        }
    }

    public validateInteger(event: InputEvent) {
        // 入力値を取得
        const input = event.data;
        // 文字削除時はdataがnullになるためそのまま通す
        if (input === null || input === '') {
            return;
        }
        // 半角数字のみを許可（0-9）
        const halfWidthDigitsPattern = /^[0-9]$/;
        // 全角数字のみを許可（０-９）
        const fullWidthDigitsPattern = /^[\uFF10-\uFF19]$/;
        // 半角数字または全角数字以外の場合は入力をキャンセル
        if (!halfWidthDigitsPattern.test(input) && !fullWidthDigitsPattern.test(input)) {
            event.preventDefault();
        }
    }

    public validateInputDecimal(event: InputEvent) {
        // 入力値を取得
        const data = event.data
        // 数値と小数点のみ許容
        const pattern = /^[.\d]*$/;
        // 文字削除時はdataがnullになるためそのまま通す
        if(data != null && !pattern.test(data)) {
            // pattern外のときは入力をキャンセルする
            return event.preventDefault()
        }
        
    }

    public exponentToDecimal(exponential: number) {
        return exponential.toFixed(10).toString().replace(/\.?0*$/, '')
    }

    public onInputFocus(event: FocusEvent): void {
        const input = event.target as HTMLInputElement;
        if (input.value) input.value = input.value.replace(/,/g, '');
    }


    public onInputBlur(event: FocusEvent, formModel: any = null, key: string, digit = 2): number | null {
        const input = event.target as HTMLInputElement;
        let value = input.value?.replace(/[\uFF10-\uFF19]/g, (char: string) =>
            String.fromCharCode(char.charCodeAt(0) - 0xFEE0)
        );
        value = value?.replace(/[^0-9.]/g, '');
        if (value && value.length > 1) {
            value = value.replace(/^0+/, '') || '0';
        }
        if (!value || isNaN(Number(value))) {
            if (formModel && key) formModel[key] = null;
            input.value = '';
            return null;
        }
        const numValue = Number(value);
        const formattedValue = this.setCommas(value, digit) ?? '';
        let roundedNumber = numValue;
        if (formattedValue) {
            const cleanString = formattedValue.replace(/,/g, '');
            roundedNumber = Number(cleanString);
        }
        if (formModel && key) {
            formModel[key] = roundedNumber;
        }
        input.value = formattedValue;
        return roundedNumber; 
    }

    public setCommas(value: string | number | null | undefined , digit = 2): string | null {
        if (value == null || value === '') return null;
        const num = Number(value);
        return isNaN(num) ? null : num.toLocaleString('ja-JP', { maximumFractionDigits: digit});
    }

    public formatJst(value: string | Date | null | undefined, pattern = 'YYYY/MM/DD HH:mm:ss'): string {
        if (!value) return '';
        return moment.utc(value).utcOffset(9 * 60).format(pattern);
    }

    validateDecimal(event: InputEvent) {
        // const data = event.data
        // if (data === null) return;
        // const halfWidthPattern = /^[0-9.]$/;
        // const fullWidthPattern = /^[\uFF10-\uFF19\uFF0E]$/;
        // if (!halfWidthPattern.test(data) && !fullWidthPattern.test(data)) {
        //     event.preventDefault();
        // }
    }

    sanitizeNumber(event: { target: { value: any; }; }) {
        let v = event.target.value;
        v = v.replace(/[\uFF10-\uFF19]/g, (char: string) =>
            String.fromCharCode(char.charCodeAt(0) - 0xFEE0)
        );
        v = v.replace(/[\uFF0E\u3002]/g, ".");
        v = v.replace(/[^0-9.]/g, "");
        const firstDot = v.indexOf(".");
        if (firstDot !== -1) {
            v =
            v.substring(0, firstDot + 1) +
            v.substring(firstDot + 1).replace(/\./g, "");
        }
        event.target.value = v;
    }

    maskDate(e: Event, model: any, prop: string, setting: number) {
        const input = e.target as HTMLInputElement;
        const raw = input.value.replace(/[\uFF10-\uFF19]/g, (char: string) =>
            String.fromCharCode(char.charCodeAt(0) - 0xFEE0)
        );
        const oldCursor = input.selectionStart ?? raw.length;
        const formattedToDigitIndex = (str: string, pos: number) => {
            return str.slice(0, pos).replace(/[^0-9]/g, "").length;
        };
        const digitIndexToFormatted = (dPos: number) => {
            if (dPos <= 4) return dPos;
            if (dPos <= 6) return dPos + 1;
            return dPos + 2;
        };
        if (setting === 1) {
            let digits = raw.replace(/\D/g, "");
            if (digits.length > 8) digits = digits.slice(0, 8);
            const year = digits.slice(0, 4).padEnd(4, "_");
            let month = digits.slice(4, 6).padEnd(2, "_");
            let day = digits.slice(6, 8).padEnd(2, "_");
            let cursorShift = 0;
            if (digits.length >= 5) {
                const m1 = digits[4];
                const m2 = digits[5] ?? "";
                if (m1 && !m2) {
                    const num = parseInt(m1, 10);
                    if (num >= 2 && num <= 9) {
                        month = "0" + m1;
                        cursorShift = 1;
                    }
                } else if (m1 && m2) {
                    let monthNum = parseInt(m1 + m2, 10);
                    if (monthNum > 12) monthNum = 12;
                    month = monthNum.toString().padStart(2, "0");
                }
            }
            if (digits.length >= 7) {
                const y = parseInt(year.replace(/_/g, "0"), 10);
                const m = parseInt(month.replace(/_/g, "1"), 10);
                const maxDay = new Date(y, m, 0).getDate();
                const d1 = digits[6];
                const d2 = digits[7] ?? "";
                if (d1 && !d2) {
                    const num = parseInt(d1, 10);
                    if (num >= 4 && num <= 9) {
                        day = "0" + d1;
                        cursorShift += 1;
                    } else {
                        day = d1 + "_";
                    }
                } else if (d1 && d2) {
                    let dayNum = parseInt(d1 + d2, 10);
                    if (dayNum > maxDay) dayNum = maxDay;
                    day = dayNum.toString().padStart(2, "0");
                }
            }
            const formatted = `${year}/${month}/${day}`;
            const digitIndex = formattedToDigitIndex(raw, oldCursor);
            const newCursor = digitIndexToFormatted(digitIndex) + cursorShift;
            input.value = formatted;
            model[prop] = formatted;
            setTimeout(() => {
                const len = formatted.length;
                const pos = Math.min(Math.max(0, newCursor), len);
                input.setSelectionRange(pos, pos);
            });
            return;
        }
        let digitsOnly = raw.replace(/\D/g, "");
        if (digitsOnly.length > 8) digitsOnly = digitsOnly.slice(0, 8);
        const yearPart = digitsOnly.slice(0, 4);
        const monthPart = digitsOnly.slice(4, 6);
        const dayPart = digitsOnly.slice(6, 8);
        let formattedSimple = yearPart;
        if (monthPart.length > 0) formattedSimple += "-" + monthPart;
        if (dayPart.length > 0) formattedSimple += "-" + dayPart;
        const digitsBeforeOld = raw.slice(0, oldCursor).replace(/\D/g, "").length;
        let newCursorPos = digitsBeforeOld <= 4 ? digitsBeforeOld : digitsBeforeOld <= 6 ? digitsBeforeOld + 1 : digitsBeforeOld + 2;
        newCursorPos = Math.min(Math.max(0, newCursorPos), formattedSimple.length);
        input.value = formattedSimple;
        model[prop] = formattedSimple;
        setTimeout(() => {
            input.setSelectionRange(newCursorPos, newCursorPos);
        });
    }   
    
    private getSegmentAtCursor(cursorPosition: number | null): 'year' | 'month' | 'day' | null {
        if (cursorPosition === null) {
            return null;
        }
        if (cursorPosition >= 0 && cursorPosition <= 4) {
            return 'year';
        }
        if (cursorPosition > 4 && cursorPosition <= 7) {
            return 'month'; 
        }
        if (cursorPosition > 7 && cursorPosition <= 10) {
            return 'day';
        }
        return null;
    }

    private getSegmentSelectionRange(segment: 'year' | 'month' | 'day', value: string): { start: number, end: number } {
        switch (segment) {
            case 'year':
                return { start: 0, end: 4 };
            case 'month':
                return { start: 5, end: 7 };
            case 'day':
                return { start: 8, end: 10 };
            default:
                return { start: 0, end: value.length };
        }
    }

     public openDatePicker(dateInputRef: HTMLElement | null, date: string): void {
        if (!dateInputRef) return;
        
        const hiddenDateInput = dateInputRef as HTMLInputElement & {
        showPicker?: () => void;
        };
        
        const v = date || "";
        const normalized = v
        .replace(/\//g, "-")
        .replace(
            /^(\d{4})-(\d{1,2})-(\d{1,2})$/,
            (_match: string, y: string, m: string, d: string) =>
            `${y}-${m.padStart(2, "0")}-${d.padStart(2, "0")}`
        );
        
        hiddenDateInput.value = normalized;
        hiddenDateInput.showPicker?.() ?? hiddenDateInput.click();
    }
  
    public onDatePicked(event: Event): string {
        const hiddenDateInput = event.target as HTMLInputElement;
        const pickedValue = hiddenDateInput.value;
        
        if (!pickedValue) {
        return "";
        }
        
        const [year, month, day] = pickedValue.split('-');
        const date = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
        return date;
    }

    public handleFocus(event: FocusEvent): void {
        const input = event.target as HTMLInputElement;
        if (this.shouldSelectAll && input.value) {
        setTimeout(() => {
            input.select();
        }, 0); 
        this.shouldSelectAll = false;
        }
        this.initialDate = input.value;
    }

    public handleMouseDown(event: MouseEvent): void {
        const input = event.target as HTMLInputElement;
        if (this.shouldSelectAll && document.activeElement === input) {
        event.preventDefault();
        }
    }

    public resetSelectFlag(date: string): string {
        const [year, month, day] = (date || "").split('-').map(Number);
        const dateObj = new Date(year, (month || 1) - 1, day || 1);

        const isValidDate =
        !isNaN(dateObj.getTime()) &&
        dateObj.getFullYear() === year &&
        dateObj.getMonth() === (month || 1) - 1 &&
        dateObj.getDate() === day;

        if (!isValidDate && date) {
        return this.initialDate;
        }
    
        this.shouldSelectAll = true;
        this.clickCount = 0;
        this.lastClickedSegment = null;
        this.flag = false;
        return date;
    }

  public handleKeyUpOrClick(event: MouseEvent): void {
        const input = event.target as HTMLInputElement;

        if (this.shouldSelectAll) {
        this.shouldSelectAll = false;
        this.clickCount = 0;
        this.lastClickedSegment = null;
        return;
        }
    
        setTimeout(() => {
        const cursorPos = input.selectionStart;
        if (this.lastClickedSegment === null && this.clickCount === 0) {
            this.lastClickedSegment = this.getSegmentAtCursor(cursorPos);
            this.flag = true;
            return;
        }
        
        if(this.flag){
            this.flag = false;
            this.lastClickedSegment = this.getSegmentAtCursor(cursorPos);
        }
        
        const currentSegment = this.getSegmentAtCursor(cursorPos);
        if (currentSegment !== this.lastClickedSegment) {
            this.clickCount = 2;
            this.lastClickedSegment = currentSegment;
        } else {
            this.clickCount++;
        }
        
        if (this.clickCount > 1 && this.clickCount % 2 === 0){
            if (currentSegment) {
            const { start, end } = this.getSegmentSelectionRange(currentSegment, input.value);
            input.setSelectionRange(start, end);
            }
        }
        }, 0);
    }

    public handleArrowKeys(event: KeyboardEvent): string {
        const input = event.target as HTMLInputElement;
        const currentValue = input.value;
        
        // Original arrow keys logic
        if (event.key !== "ArrowUp" && event.key !== "ArrowDown") return currentValue;
        
        let date = currentValue ? new Date(currentValue.replace(/\//g, '-')) : new Date();
        if (isNaN(date.getTime())) date = new Date();
        
        date.setDate(date.getDate() + (event.key === "ArrowUp" ? 1 : -1));
        
        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, "0");
        const dd = String(date.getDate()).padStart(2, "0");
        const formattedDate = `${yyyy}-${mm}-${dd}`;
        
        this.initialDate = formattedDate;
        
        setTimeout(() => {
            input.setSelectionRange(0, formattedDate.length);
        }, 0);
        
        event.preventDefault();
        return formattedDate;
    }

}